import { DEFAULT_PRODUCTION_RATES } from '../siteTakeoffConstants';

// Translate the three global frequency pickers into a rateOverrides object
// that calculateLaborHours understands. mtc frequency drives the routine
// per-visit total via _visitsPerYear; irrigation/herbicide drive their
// category services' visitsPerYear.
export function buildRateOverrides({ mtcVisits, irrigationVisits, herbicideVisits }, baseRateOverrides = {}) {
  const out = { ...baseRateOverrides };
  const mtcNum = mtcVisits != null && mtcVisits !== '' ? Number(mtcVisits) : NaN;
  if (Number.isFinite(mtcNum)) {
    out._visitsPerYear = mtcNum;
  } else if (baseRateOverrides._visitsPerYear != null) {
    out._visitsPerYear = baseRateOverrides._visitsPerYear;
  }

  Object.entries(DEFAULT_PRODUCTION_RATES).forEach(([svc, cfg]) => {
    let visits;
    if (cfg.category === 'irrigation') visits = Number(irrigationVisits);
    else if (cfg.category === 'herbicide') visits = Number(herbicideVisits);
    else return;
    if (!Number.isFinite(visits)) return;
    out[svc] = { ...(out[svc] || {}), visitsPerYear: visits };
  });

  return out;
}

export default buildRateOverrides;
